export const openNativeDatePicker = (input) => {
  if (!input) {
    return false;
  }
  input.focus({ preventScroll: true });
  if (typeof input.showPicker !== "function") {
    return false;
  }
  try {
    input.showPicker();
    return true;
  } catch {
    return false;
  }
};